
import { TOOLTIP_STATUS, TOOLTIPS } from '../../util/constants';
import { Mui } from '@osu/react-ui';
import { Link } from "react-router-dom";

const InProgressTable = ({ isLoading, filteredTableData }) => {
  return (
    <Mui.TableContainer>
      <Mui.Table sx={{ minWidth: '100%' }} aria-label="in progress list">
        <Mui.TableHead>
          <Mui.TableRow>
            <Mui.TableCell>ID</Mui.TableCell>
            <Mui.TableCell>Last Name</Mui.TableCell>
            <Mui.TableCell>First Name</Mui.TableCell>
            <Mui.TableCell>Program</Mui.TableCell>
          </Mui.TableRow>
        </Mui.TableHead>
        <Mui.TableBody>
          {isLoading ? (
            <Mui.TableRow>
              <Mui.TableCell colSpan={6} component="th" scope="row">
                <Mui.Skeleton variant="rect" width="100%" height="2rem" />
              </Mui.TableCell>
            </Mui.TableRow>
          ) : (
            filteredTableData?.map((row) => (
            //   console.log("Row", row),
              <Mui.TableRow key={`${row.applicantEmployeeId}-${row.program?.key}-${row.term}`}>
                <Mui.TableCell component="th" scope="row">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Mui.Link component={Link} to={`/applicant/${row.applicantEmployeeId}/${row.programId}/${row.term}`}> {row.applicantEmployeeId} </Mui.Link>
                    {row.resumeLater && TOOLTIPS(TOOLTIP_STATUS.RESUMELATER)}
                    {row.pastDue && TOOLTIPS(TOOLTIP_STATUS.PASTDUE)}
                    {row.manuallyAssigned && TOOLTIPS(TOOLTIP_STATUS.ASSIGNED)}
                    {row.training && TOOLTIPS(TOOLTIP_STATUS.TRAINING)}
                  </div>
                </Mui.TableCell>
                <Mui.TableCell>{row.lastName}</Mui.TableCell>
                <Mui.TableCell>{row.firstName}</Mui.TableCell>
                <Mui.TableCell>{row.programLabel ?? 'N/A'}</Mui.TableCell>
              </Mui.TableRow>
            ))
          )}
        </Mui.TableBody>
      </Mui.Table>
    </Mui.TableContainer>
  )
}

export default InProgressTable